<template>
  <div class="top el-form--label-left">
    <el-form-item label="上报条件">
      <el-radio-group v-model="report_condition" @change="changeReportCondition">
        <el-radio-button
          v-for="item in [
            { label: '全部条件', value: 1 },
            { label: '指定条件', value: 2 }
          ]"
          :key="item.value"
          :label="item.value"
          >{{ item.label }}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
    <draggable
      v-model="innerSettings"
      animation="200"
      handle=".sort"
      ghostClass="ghost"
      chosenClass="chosen"
      @start="onDragStart"
      @end="onDragEnd"
    >
      <transition-group>
        <div class="ladder" v-for="(item, i) in innerSettings" :key="i">
          <div class="ladder-branch" v-if="report_condition === 2">
            <span>阶梯{{ i + 1 }}</span>
            <div v-if="i == innerSettings.length - 1">
              <el-button v-if="i < 19" type="text" @click="addSetting()">+增加阶梯</el-button>
            </div>
          </div>

          <div v-show="isDragMoving"></div>
          <div v-show="!isDragMoving" class="condition">
            <div class="close-btn el-icon-circle-close" v-if="innerSettings.length > 1" @click="innerSettings.splice(i, 1)"></div>
            <div class="sort-btn sort el-icon-sort" v-if="innerSettings.length > 1"></div>

            <div class="condition-child" v-if="report_condition === 2">
              <div class="tree-branch" v-if="item.conditions.length > 1">
                <div class="icon-condition" @click="item.relation_type = item.relation_type === 1 ? 2 : 1">
                  <div class="icon">{{ item.relation_type === 1 ? '且' : '或' }}</div>
                </div>
              </div>

              <div class="input-groups">
                <el-form-item
                  :class="idx === item.conditions.length - 1 ? 'input-group last-input-child' : 'input-group'"
                  v-for="(condition, idx) in item.conditions"
                  :key="idx"
                  label-width="0px"
                  :prop="'reportConfig.pay_call.settings.' + i + '.conditions.' + idx"
                  :rules="{ validator: conditionValidtor }"
                >
                  <el-select
                    v-model="condition.condition_type"
                    @change="onConditionTypeChange(condition, $event)"
                    placeholder="请选择条件"
                    class="condition-select"
                  >
                    <el-option v-for="i in CONDITION_TYPE_OPTS" :key="i.value" :label="i.label" :value="i.value"></el-option>
                  </el-select>

                  <!--  withMediaKeys 包含的字段才显示 -->
                  <el-select
                    v-if="withMediaKeys.includes(condition.condition_type)"
                    v-model="condition.limit_current_media"
                    placeholder="请选择媒体"
                    style="width: 130px"
                    class="condition-select"
                  >
                    <el-option label="全部媒体" value="-1"></el-option>
                    <el-option label="用户所在媒体" value="1"></el-option>
                  </el-select>

                  <el-select v-model="condition.operator_type" placeholder="请选择操作符" style="width: 120px" class="operator-select">
                    <el-option
                      v-for="op in getOperatorOpts(condition.condition_type)"
                      :key="op.value"
                      :label="op.label"
                      :value="op.value"
                    ></el-option>
                  </el-select>

                  <el-select
                    v-if="[CONDITION_TYPE.wechatPayType, CONDITION_TYPE.createRoleTimeDiff].includes(condition.condition_type)"
                    v-model="condition.value"
                    placeholder="请选择"
                    style="width: 180px"
                  >
                    <el-option
                      v-for="opt in getConditionValueOpts(condition.condition_type)"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>

                  <el-input v-else v-model.trim="condition.value" placeholder="请输入值" class="value-input">
                    <template #append>
                      <span v-if="condition.condition_type.includes('Roi')">%</span>
                    </template>
                  </el-input>

                  <i class="el-icon-close dele" v-if="idx > 0" @click="item.conditions.splice(idx, 1)"></i>
                  <el-button v-else type="text" @click="addCondition(item.conditions)">+增加限制条件</el-button>
                </el-form-item>
              </div>
            </div>
            <div class="condition-fixed">
              <el-form-item label="上报方式">
                <el-radio-group v-model="item.callback_type">
                  <el-radio-button
                    v-for="item in [
                      { label: '全部上报', value: 1 },
                      { label: '全部禁报', value: 2 },
                      { label: '随机上报', value: 3 }
                    ]"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="" v-if="item.callback_type === 3" prop="reportingPayRuleRate">
                <span>上报比例 </span>
                <el-input v-model="item.callback_rate" placeholder="请输入值" class="value-input" />
                <span>%</span>
              </el-form-item>
              <el-form-item label="" v-if="item.callback_type === 4" prop="reportingPayRuleRate">
                <span>上报 </span>
                <el-input v-model="item.recyle_offset" placeholder="请输入值" class="value-input" />
                <span>笔后,不上报 </span>
                <el-input v-model="item.recyle_interval" placeholder="请输入值" class="value-input" />
                <span>笔</span>
              </el-form-item>
              <el-form-item label="上报金额" prop="reportingPayRuleMoney">
                <el-select
                  v-model="item.money_type"
                  placeholder="请选择条件"
                  class="condition-select"
                  @change="changeMoneyType($event, item)"
                >
                  <el-option label="原始金额(元)" :value="amountEnum.ORIGINAL_AMOUNT"></el-option>
                  <el-option label="固定金额(元)" :value="amountEnum.FIXED_AMOUNT"></el-option>
                  <el-option label="系数金额(%)" :value="amountEnum.COEFFICIENT_AMOUNT"></el-option>
                  <el-option label="随机金额(元)" :value="amountEnum.RANDOM_AMOUNT"></el-option>
                </el-select>
                <el-input
                  v-model.trim="item.money_value"
                  :disabled="item.money_type === amountEnum.ORIGINAL_AMOUNT"
                  placeholder="请输入值"
                  class="value-input"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import DataReports, {
  amountEnum,
  OPERATOR_TYPE_LIST,
  WECHAT_PAY_OPERATOR_TYPE_LIST,
  CONDITION_TYPE,
  CONDITION_TYPE_OPTS,
  WECHAT_PAY_TYPE_OPTS,
  CREATE_ROLE_TIME_DIFF_OPTS,
  withMediaKeys,
  twoDigit,
  int59RegExp
} from '../data/data-reports.class'
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  props: {
    settings: {
      type: Array, // 已选结果
      required: true
    },
    reportType: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      isDragMoving: false,
      amountEnum,
      OPERATOR_TYPE_LIST,
      CONDITION_TYPE,
      CONDITION_TYPE_OPTS,
      WECHAT_PAY_TYPE_OPTS,
      CREATE_ROLE_TIME_DIFF_OPTS,
      withMediaKeys,
      report_condition: 2,
      innerSettings: this.settings
    }
  },
  methods: {
    getConditionValueOpts(type) {
      return type === CONDITION_TYPE.wechatPayType ? WECHAT_PAY_TYPE_OPTS : CREATE_ROLE_TIME_DIFF_OPTS
    },
    getOperatorOpts(type) {
      return type === CONDITION_TYPE.wechatPayType ? WECHAT_PAY_OPERATOR_TYPE_LIST : OPERATOR_TYPE_LIST
    },
    onConditionTypeChange(condition, val) {
      // 切换到 用户支付平台、支付创角时间差 时，清空value，让用户重新选择
      if ([CONDITION_TYPE.wechatPayType, CONDITION_TYPE.createRoleTimeDiff].includes(val)) {
        condition.value = ''
      }
    },
    onDragStart() {
      this.isDragMoving = true
    },
    onDragEnd() {
      this.isDragMoving = false
      this.updateSettings(this.innerSettings)
    },
    updateSettings(settings) {
      this.$emit('update:settings', settings)
    },
    conditionValidtor(rule, value, callback) {
      const { reportConfig } = this.$parent.model
      const { pay_call_check } = reportConfig

      if (pay_call_check) {
        const { condition_type, operator_type, limit_current_media, value: valueText } = value || {}
        if (!condition_type) {
          return callback(new Error('请选择条件'))
        }
        if (!operator_type) {
          return callback(new Error('请选择操作符'))
        }
        if (withMediaKeys.includes(condition_type)) {
          if (!limit_current_media) {
            return callback(new Error('请选择媒体'))
          }
        }

        if ([CONDITION_TYPE.gameCallbackRoi, CONDITION_TYPE.gameCallbackRoi7d].includes(condition_type)) {
          if (!twoDigit.test(valueText)) {
            return callback(new Error('请输入数字，最多保留2位小数'))
          }
        } else if ([CONDITION_TYPE.wechatPayType, CONDITION_TYPE.createRoleTimeDiff].includes(condition_type)) {
          if (!valueText) {
            return callback(new Error('请选择值'))
          }
        } else {
          if (!int59RegExp.test(valueText)) {
            return callback(new Error('条件判断值请输入1~99999正整数'))
          }
        }
      }

      callback()
    },
    changeReportCondition(val) {
      this.innerSettings = [DataReports.getDefaultSettings()]
      this.updateSettings(this.innerSettings)
      this.$emit('change-report-type', val)
    },
    addCondition(conditions) {
      conditions.push({
        condition_type: '',
        operator_type: '',
        value: ''
      })
    },
    addSetting() {
      this.innerSettings.push({
        order: this.settings.length + 1,
        ...DataReports.getDefaultSettings()
      })
      this.updateSettings(this.innerSettings)
    },
    changeMoneyType(val, item) {
      if (val === 1) {
        item.money_value = ''
      }
    }
  },
  created() {
    this.report_condition = this.reportType
  }
}
</script>

<style lang="scss" scoped>
.top {
  border: #ccc 1px solid;
  border-radius: 4px;
  margin: 20px 0;
  padding: 24px 24px 4px 24px;
  margin-left: 80px;
}
.ladder {
  padding: 20px;
  display: flex;
  align-items: center;
  background: #fff;
  &.chosen {
    background: #f5f5f5;
  }
  &.ghost {
    background: #f5f5f5;
  }
}

.ladder-branch {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  flex: 1;
}

.condition {
  position: relative;
  display: flex;
  flex-direction: column;
  border: #ccc 1px solid;
  border-radius: 4px;
  padding: 18px;
  flex: 11;

  &:hover {
    .close-btn {
      display: block;
    }

    .sort-btn {
      display: block;
    }
  }
}

.condition-child {
  display: flex;
  align-items: center;
}

.tree-branch {
  display: flex;
  align-items: center;
  margin-right: 18px;
}

.icon-condition {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
}

.icon {
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.input-groups {
  display: flex;
  flex-direction: column;
}

.input-group {
  display: flex;
  align-items: center;
  margin-top: 18px;
  margin-left: 0px;
}

.last-input-child {
  margin-bottom: 18px;
}

.condition-select,
.operator-select,
.value-input {
  margin-right: 10px;
  width: 200px;
}

.condition-fixed {
  margin-top: 18px;
}

.add-condition {
  position: absolute;
  bottom: -24px;
}

.dele {
  font-size: 16px;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: -12px;
  right: -12px;
  z-index: 10;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #333;
  border-radius: 50%;
  cursor: pointer;
  font-size: 22px;
  line-height: 24px;
  display: none;
}

.sort-btn {
  cursor: move;
  position: absolute;
  top: -12px;
  right: 22px;
  z-index: 10;
  width: 22px;
  height: 22px;
  font-size: 20px;
  display: none;
}
</style>
